import { React, useEffect, useState, useContext } from 'react';
import { AuthContext } from '../../contexts/authContext';
import { useParams, useNavigate, useLocation } from "react-router-dom";

import { Carousel } from '@mantine/carousel';
import { IconTag, IconKey, IconGift, IconMapPin , IconBuildingEstate, IconPhoto, IconHeart, IconHeartFilled, IconPackage, IconTruckDelivery, IconLeaf, IconInfoCircle } from '@tabler/icons-react';
import { Loader, Button, Modal } from '@mantine/core';
import { DatePicker } from '@mantine/dates';
import { startOfDay, addDays, differenceInCalendarDays } from 'date-fns';
import dayjs from "dayjs";
import "dayjs/locale/fr";


import ClosePageOverPictureButtonwithModal from '../../composents/Buttons/All/ClosePageOverPictureButtonwithModal/ClosePageOverPictureButtonwithModal';
import { calculateServiceFeeVAT } from './vatConfig';

const OfferCard = (props) => {
    const { getToken } = useContext(AuthContext);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768); 
    const [offer, setOffer] = useState(null);
    const [isFavorite, setIsFavorite] = useState(false);
    const [modalOpened, setModalOpened] = useState(false);
    const [selectedRange, setSelectedRange] = useState([null, null]);
    const [locks, setLocks] = useState([]);
    const [currentLockId, setCurrentLockId] = useState(null);
    const [userId, setUserId] = useState(null);
    const [user, setUser] = useState(null);
    const [addressModal, setAddressModal] = useState(false);
    const [companyModalOpened, setCompanyModalOpened] = useState(false);
    const [co2ModalOpened, setCo2ModalOpened] = useState(false);
    const [pendingChat, setPendingChat] = useState(false);
    const [isOpeningChat, setIsOpeningChat] = useState(false);
    const [isPaying, setIsPaying] = useState(false);
    const [lockSecondsLeft, setLockSecondsLeft] = useState(null);
    const isEditOffer = props.isEditOffer;
    const desktopFooterActions = props.desktopFooterActions;
    const desktopBackButton = props.desktopBackButton;

    let { id } = useParams()
    dayjs.locale("fr");
    const navigate = useNavigate();
    const location = useLocation();
    const qp = new URLSearchParams(location.search);
    const chatStart = qp.get("start");
    const chatEnd   = qp.get("end");

    useEffect(() => {
        const token = getToken();
        if (!token) {
            navigate("/app/login");
            return;
        };
        getUser();

        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
          };
          window.addEventListener('resize', handleResize);
          return () => {
            window.removeEventListener('resize', handleResize);
          };
          // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const getUser = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch('https://boldee-97d8d36af3bd.herokuapp.com/app/getUser', {
            // const response = await fetch('https://boldee-97d8d36af3bd.herokuapp.com/s/getUser', {

                method: "GET",    
                headers: {
                    Authorization: `Bearer ${token}`
                    }
        });
            const data = await response.json()
            setUserId(data._id)
            setUser(data);
        }   catch (error) {
            return null;
        }
    }

    const getSingleOffer = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`https://boldee-97d8d36af3bd.herokuapp.com/app/offers/offer/${id}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            const offerData = await response.json();
            if (Array.isArray(offerData.availabilityDates)) {
                offerData.availabilityDates = offerData.availabilityDates
                    .filter(r => r?.startDate && r?.endDate)
                    .map(r => ({
                    startDate: new Date(r.startDate),
                    endDate: new Date(r.endDate)
                    }))
                    .sort((a, b) => a.startDate - b.startDate);
                } else {
                offerData.availabilityDates = [];
                }
            setOffer(offerData);
            return offerData;
        } catch (error) {
        }
    };
    

    const checkIfFavorite = async () => {
        try {
            const token = getToken();
            const res = await fetch(
                "https://boldee-97d8d36af3bd.herokuapp.com/app/offers/favlist",
                {
                    method: "GET",
                    headers: { Authorization: `Bearer ${token}` }
                }
            );

            const favIds = await res.json(); // doit être array d'IDs

            if (Array.isArray(favIds)) {
                setIsFavorite(
                    favIds.includes(id)
                );
            }
        } catch (err) {
            console.error(err);
        }
    };

    const getActiveLocks = async (offerId) => {
        try {
            if (!offerId) return;

            const token = localStorage.getItem("token");

            const res = await fetch(
            `https://boldee-97d8d36af3bd.herokuapp.com/app/offers/book-temp/${offerId}`,
            {
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            }
            );

            if (!res.ok) {
            setLocks([]);
            return;
            }

            const data = await res.json();

            // on s'assure que c'est bien un tableau
            setLocks(Array.isArray(data) ? data : []);

        } catch (e) {
            console.error("get locks:", e);
            setLocks([]);
        }
    };


    useEffect(() => {
        const fetchOffer = async () => {
            const data = await getSingleOffer();
            if (!data?._id) return;

            await checkIfFavorite();
            await getActiveLocks(data._id);
        };

        fetchOffer();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const myLock = locks?.find((l) => l.user === userId);

    // Compte à rebours du lock
    useEffect(() => {
        if (!myLock?.expiresAt) {
            setLockSecondsLeft(null);
            return;
        }
        const calc = () => Math.max(0, Math.round((new Date(myLock.expiresAt) - Date.now()) / 1000));
        setLockSecondsLeft(calc());
        const interval = setInterval(() => {
            const s = calc();
            setLockSecondsLeft(s);
            if (s === 0) {
                // Lock expiré : nettoyer localement
                setLocks([]);
                setCurrentLockId(null);
                clearInterval(interval);
            }
        }, 1000);
        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [myLock?.expiresAt]);

    const fmtCountdown = (s) => {
        if (s === null || s === undefined) return "";
        const m = Math.floor(s / 60);
        const sec = s % 60;
        return `${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
    };

    const today = new Date().toISOString();

    const startDay = (d) => startOfDay(new Date(d));

    const isMonday = (d) => startDay(d).getDay() === 1; // 1 = lundi

    const computeWeekRange = (mondayDate) => {
        const monday = startDay(mondayDate);
        const sunday = addDays(monday, 6);
        return [monday, sunday];
    };


    const openBookingModal = async (prefillStart, prefillEnd) => {
        if (!offer?._id) return;
        await getActiveLocks(offer._id);
        if (prefillStart && prefillEnd) {
            setSelectedRange([new Date(prefillStart), new Date(prefillEnd)]);
        } else {
            setSelectedRange([null, null]);
        }
        setModalOpened(true);
    };

    const toggleFavorite = async () => {
        try {
            const token = getToken();

            if (!isFavorite) {
                await fetch(
                    `https://boldee-97d8d36af3bd.herokuapp.com/app/offers/addfavlist/${id}`,
                    {
                        method: "POST",
                        headers: { Authorization: `Bearer ${token}` }
                    }
                );
                setIsFavorite(true);
            } else {
                await fetch(
                    `https://boldee-97d8d36af3bd.herokuapp.com/app/offers/delfavlist/${id}`,
                    {
                        method: "DELETE",
                        headers: { Authorization: `Bearer ${token}` }
                    }
                );
                setIsFavorite(false);
            }
        } catch (err) {
            console.error(err);
        }
    };
    

    const normalize = (d) => {
        const x = new Date(d);
        if (Number.isNaN(x.getTime())) return null;
        return new Date(x.getFullYear(), x.getMonth(), x.getDate());
        };

    const safeIsWithin = (day, start, end) => {
    if (!start || !end) return false;
    if (start > end) return false;
    return day >= start && day <= end;
    };

    const isFrenchHoliday = (date) => {
        const y = date.getFullYear(), m = date.getMonth() + 1, d = date.getDate();
        const a = y % 19, b = Math.floor(y / 100), c = y % 100;
        const dd = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
        const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - dd - g + 15) % 30;
        const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
        const mm = Math.floor((a + 11 * h + 22 * l) / 451);
        const easterMonth = Math.floor((h + l - 7 * mm + 114) / 31);
        const easterDay = ((h + l - 7 * mm + 114) % 31) + 1;
        const easter = new Date(y, easterMonth - 1, easterDay);
        const lundi = new Date(easter); lundi.setDate(easter.getDate() + 1);
        const ascension = new Date(easter); ascension.setDate(easter.getDate() + 39);
        const pentecote = new Date(easter); pentecote.setDate(easter.getDate() + 50);
        const fixed = [[1,1],[5,1],[5,8],[7,14],[8,15],[11,1],[11,11],[12,25]];
        const isFixed = fixed.some(([fm, fd]) => m === fm && d === fd);
        const isMoving = [lundi, ascension, pentecote].some(fv =>
            fv.getFullYear() === y && fv.getMonth() + 1 === m && fv.getDate() === d
        );
        return isFixed || isMoving;
    };

    const isDateUnavailable = (date) => {
        if (!offer?.availabilityDates?.length) return true;

        if (
            offer?.availabilityDates.every(r => !r.startDate || !r.endDate)
        ) return true;

        const dow = date.getDay();
        if (offer.allowWeekends === false && (dow === 0 || dow === 6)) return true;
        if (offer.allowHolidays === false && isFrenchHoliday(date)) return true;

        const day = normalize(date);

        const available = offer?.availabilityDates.some(({ startDate, endDate }) => {
            const s = normalize(startDate);
            const e = normalize(endDate);
            return safeIsWithin(day, s, e);
        });

        if (!available) return true;

    const locked = locks?.some((lock) => {
    if (!lock?.start || !lock?.end) return false;

    if (lock.user === userId) return false;

    return safeIsWithin(
        day,
        normalize(lock.start),
        normalize(lock.end)
    );
});

        if (locked) return true;

        const booked = offer?.bookedRangeDates?.some((range) => {
            if (!range?.start || !range?.end) return false;
            return safeIsWithin(
            day,
            normalize(range.start),
            normalize(range.end)
            );
        });

        return booked;
    };

    // Normaliser à minuit UTC — même logique que book-temp côté backend, pour que
    // la conversation créée via "Contacter l'annonceur" matche exactement celle
    // retrouvée par le webhook Stripe au moment du paiement (mêmes startDate/endDate)
    const toDayUTC = (d) => {
        const dt = new Date(new Date(d).getTime() + 12 * 60 * 60 * 1000);
        return new Date(Date.UTC(dt.getUTCFullYear(), dt.getUTCMonth(), dt.getUTCDate()));
    };

    const handleConfirmBooking = async () => {
        if (!selectedRange || !selectedRange[0]) return;

        const start = toDayUTC(selectedRange[0]);
        const end = selectedRange[1] ? toDayUTC(selectedRange[1]) : toDayUTC(selectedRange[0]);
        const startISO = start.toISOString();
        const endISO = end.toISOString();

        const token = localStorage.getItem("token");

        setModalOpened(false);
        setSelectedRange([null, null]);

        // "Contacter l'annonceur" → pas de lock, ouvre directement la conv avec les dates
        if (pendingChat) {
            setPendingChat(false);
            try {
                const res = await fetch("https://boldee-97d8d36af3bd.herokuapp.com/app/msg/create", {
                    method: "POST",
                    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
                    body: JSON.stringify({ offerId: offer._id, sellerId: offer.author?._id, startDate: startISO, endDate: endISO })
                });
                const data = await res.json();

                // Message système visible par les deux parties
                const fmt = (d) => new Date(d).toLocaleDateString("fr-FR");
                const isSameDay = startISO.slice(0, 10) === endISO.slice(0, 10);
                const dateLabel = isSameDay ? fmt(startISO) : `${fmt(startISO)} → ${fmt(endISO)}`;
                await fetch(`https://boldee-97d8d36af3bd.herokuapp.com/app/msg/conversations/${data.conversationId}/system-message`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
                    body: JSON.stringify({ content: `Demande de contact pour : ${dateLabel}` })
                });

                const params = new URLSearchParams();
                params.set("start", startISO);
                params.set("end", endISO);
                if (isMobile) {
                    navigate(`/app/msg/chat/${data.conversationId}?${params.toString()}`);
                } else {
                    params.set("conv", data.conversationId);
                    navigate(`/app/msg/list?${params.toString()}`);
                }
            } catch (err) {
                console.error("Network error:", err);
            }
            return;
        }

        // "Vérifier la disponibilité" → lock 15 min, reste sur la page offre
        try {
            const res = await fetch(
                `https://boldee-97d8d36af3bd.herokuapp.com/app/offers/book-temp/${offer._id}`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
                    body: JSON.stringify({ rangeDates: [startISO, endISO] }),
                }
            );
            const data = await res.json();
            if (!res.ok) {
                alert(data.message || "Ce créneau n'est plus disponible.");
                return;
            }
            if (data.lock) {
                setLocks((prev) => [...prev.filter((l) => l.user !== userId), data.lock]);
                setCurrentLockId(data.lock.id);
            }
        } catch (err) {
            console.error("Network error:", err);
        }
    };

    const handleModifyBooking = async (e) => {
        if (e) e.stopPropagation();
        const token = localStorage.getItem("token");

        // Sauvegarder les dates AVANT de modifier l'état
        const lockStart = myLock?.start;
        const lockEnd = myLock?.end;
        const lockIdToDelete = currentLockId;

        // Pré-remplir et ouvrir le modal immédiatement
        if (lockStart && lockEnd) {
            setSelectedRange([new Date(lockStart), new Date(lockEnd)]);
        } else {
            setSelectedRange([null, null]);
        }
        setLocks((prev) => prev.filter((l) => l.user !== userId));
        setCurrentLockId(null);
        setModalOpened(true);

        // Supprimer le lock en arrière-plan
        if (lockIdToDelete) {
            try {
                await fetch(
                    `https://boldee-97d8d36af3bd.herokuapp.com/app/offers/remove-lock/${lockIdToDelete}`,
                    { method: "DELETE", headers: { Authorization: `Bearer ${token}` } }
                );
            } catch (err) {
                console.error("remove-lock:", err);
            }
        }
    };

    const computeNbOfRentUnits = () => {
        if (!myLock) return 1;

        const start = new Date(myLock.start);
        const end = new Date(myLock.end);

        return differenceInCalendarDays(end, start) + 1;
    };

    const computeSubtotal = () => {
        const units = computeNbOfRentUnits();
        return units * offer.price;
    };

    // Frais de service HT (3% du sous-total, jamais appliqué à un Don)
    const computeServiceFeeHt = () => {
        const subtotal = computeSubtotal();
        return offer.contrat === "Don" ? 0 : Math.round(subtotal * 0.03 * 100) / 100;
    };

    // Frais de service TTC (HT + TVA 20% sur les frais de service uniquement — jamais sur
    // le prix de la ressource ni sur la caution, jamais sur un Don)
    const computeServiceFeeVat = () => calculateServiceFeeVAT(computeServiceFeeHt());

    const computeCommission = () => computeServiceFeeVat().amountTtc;

    const computeTotalPrice = () => {
        const subtotal = computeSubtotal();
        const serviceFeeTtc = computeServiceFeeVat().amountTtc;
        // La caution n'est jamais prélevée : affichée à part, jamais incluse dans le total facturé.
        const total = subtotal + serviceFeeTtc;

        return Number(total.toFixed(2));
    };

    const isAddressComplete = (address) => {
        if (!address) return false;

        const { street, postalcode, city, country } = address;

        return [street, postalcode, city, country].every(
            (field) => field && field.trim() !== ""
        );
    };

    const handlePayment = async (offerId, nbOfRentUnits, overrideLock) => {
    if (isPaying) return;
    setIsPaying(true);
    try {
        const token = localStorage.getItem("token");

        const activeLock = overrideLock || myLock;

        if (offer.contrat === "Location" && !activeLock) {
            console.error("Aucun lock");
        return;
        }

        const payload = {
        offerId,
        nbOfRentUnits
        };

        if (offer.contrat === "Location" && activeLock) {
        payload.lockId = activeLock.id;

        if (activeLock.start && activeLock.end) {
            payload.startDate = new Date(activeLock.start).toISOString();
            payload.endDate = new Date(activeLock.end).toISOString();
        }
        }

        const response = await fetch(
            "https://boldee-97d8d36af3bd.herokuapp.com/app/payment/create-checkout-session",
        {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            },
            credentials: "include",
            body: JSON.stringify(payload),
        }
        );

        if (!response.ok) {
        throw new Error("Erreur lors de la création de la session Stripe");
        }

        const data = await response.json();

        window.location.href = data.url;
        return;

    } catch (error) {
        console.error("Erreur paiement :", error);
        setIsPaying(false);
    }
    };

    useEffect(() => {
    console.log("selectedRange changed:", selectedRange);
    }, [selectedRange]);

    const handleOpenChat = async () => {
        if (isOpeningChat) return;
        setIsOpeningChat(true);
        try {
            if (offer?.contrat === "Location") {
                // Toujours proposer le calendrier pour choisir un créneau
                setPendingChat(true);
                await openBookingModal();
            } else {
                const token = getToken();
                const res = await fetch(
                    "https://boldee-97d8d36af3bd.herokuapp.com/app/msg/create",
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
                        body: JSON.stringify({ offerId: offer._id, sellerId: offer.author?._id })
                    }
                );
                const data = await res.json();
                // En desktop, Chatpage.js n'affiche que la conversation seule, sans
                // le style de la liste — on atterrit plutôt dans Messages (List.js)
                // avec cette conversation présélectionnée, comme un clic normal
                // depuis la liste. Le mobile garde la page de chat autonome.
                if (isMobile) {
                    navigate(`/app/msg/chat/${data.conversationId}`);
                } else {
                    navigate(`/app/msg/list?conv=${data.conversationId}`);
                }
            }
        } finally {
            setIsOpeningChat(false);
        }
    };


console.log(offer)

    return (
        offer  ?
            <>
                {isMobile ? (
                    <>
                        <div>
                            <Carousel
                                height={250}
                                slideSize="33.333333%"
                                slideGap="md"
                                breakpoints={[
                                    { maxWidth: 'md', slideSize: '50%' },
                                    { maxWidth: 'sm', slideSize: '100%', slideGap: 0 },
                                ]}
                                loop
                                align="start">

                                {offer.pictures.length > 0
                                    ?   <>
                                            {offer.pictures.map((url) => (
                                                <Carousel.Slide key={url}>
                                                    <img className="imgCarroussel"
                                                        src={url}
                                                        alt='img_rsc'/>
                                                </Carousel.Slide>
                                            ))}
                                        </>
                                    :   <>
                                            <div className='horizontal iCenter jCenter w100 dGreyT'><IconPhoto width={48} height={48}/></div>
                                        </>     
                                }            
                            </Carousel>
                            
                            {isEditOffer
                                ?   <ClosePageOverPictureButtonwithModal />
                                :   ""
                            }   
                        </div>

                        <div className="offer-first-lines-info">
                            {(offer.status === "open") && (offer.contrat === "Location") && (new Date(offer?.availabilityDates[1]) > today)
                                ?   <div>
                                        <p className='txt15 rT mediumplus txtCenter'>Mettez à jour les disponibilités de votre location.</p>
                                    </div>
                                    :   ""
                            }
                            {/* titre */}
                            <div className='horizontal spaceBtw iEnd'>
                                <h1 className="txt20 mrgT20 mrgB5 wraped">{offer.title}</h1>
{userId !== offer?.author?._id && (
  <div
    onClick={toggleFavorite}
    style={{ cursor: "pointer" }}
  >
    {isFavorite ? (
      <IconHeartFilled size={26} stroke={1.5} fill="red" />
    ) : (
      <IconHeart size={26} stroke={1.5} />
    )}
  </div>
)}
                            </div>
                            
                            {/* prix */}
                            <div className='horizontal'>
                                <div>
                                    {offer.price != null && (
                                        <h1 className="txt20 mediumPlus noMrgT noMrgB mrgR5">
                                            {Number(offer.price).toFixed(2)} €
                                        </h1>
                                    )}
                                </div>
                                <div>
                                    {offer.contrat === "Location" && (
                                        <h1 className="txt20 mediumPlus noMrgT noMrgB">/ jour</h1>
                                    )}
                                </div>
                            </div>
                            {offer.contrat === "Location" && offer.caution > 0 && (
                                <p className="noMrgT txt13" style={{ color: "#666" }}>
                                    Caution : {Number(offer.caution).toFixed(2)} €
                                </p>
                            )}

                            {/* type de contrat */}
                            <div>
                                {offer.contrat === "Vente" && (
                                    <div className='horizontal iCenter'>
                                        <div className='noMrgTB'><IconTag width={15} height={12} /></div>
                                        <div className="txt13 noMrgTB"><p className='noMrgTB mrgL3'>Vente sécurisée</p></div>
                                    </div>
                                )}
                                {offer.contrat === "Location" && (
                                    <div className='horizontal iCenter'>
                                        <div className='noMrgTB'><IconKey width={15} height={12} /></div>
                                        <div className="txt13 noMrgTB"><p className='noMrgTB mrgL3'>Location sécurisée</p></div>
                                    </div>
                                )}
                                {offer.contrat === "Don" && (
                                    <div className='horizontal iCenter'>
                                        <div className='noMrgTB'><IconGift width={15} height={12} /></div>
                                        <div className="txt13 noMrgTB"><p className='noMrgTB mrgL3'>Don</p></div>
                                    </div>
                                )}

                            </div>

                            {/* impact CO2 : estimation, Vente/Don uniquement */}
                            {offer.contrat !== "Location" && offer.co2Estimate && (
                                <div className="horizontal iCenter mrgT5" style={{ gap: 6 }}>
                                    <IconLeaf width={15} height={15} color="#2e7d32" />
                                    <p className="txt13 noMrgTB" style={{ color: '#2e7d32' }}>
                                        ≈ {offer.co2Estimate.avoidedKg} kg CO₂e potentiellement évités
                                    </p>
                                    <IconInfoCircle
                                        width={14}
                                        height={14}
                                        color="#999"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => setCo2ModalOpened(true)}
                                    />
                                </div>
                            )}

                            {/* lieu de la ressource */}
                            <div className="horizontal spaceBtw wraped mrgT10 medium noMrgB">
                                <div className="horizontal iCenter mrgB5 mrgR20">
                                    <IconMapPin width={15} height={15} className="mrgR10" />
                                    <span className="txt15">{offer.cityOfIntervention}</span>
                                </div>
                            </div>

                            <> {offer.author?.company
                                    ?
                                        <div className="horizontal spaceBtw wraped noMrgT medium">
                                            <div
                                                className="horizontal iCenter mrgB10 mrgR20"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => setCompanyModalOpened(true)}
                                            >
                                                <IconBuildingEstate width={15} height={15} className="mrgR10" />
                                                <div className="txt15 underline">{offer.author?.company?.name}</div>
                                            </div>
                                        </div>
                                    : ""
                                }
                            </>

                            <>
                                
                                {offer.contrat === "Location" &&
                                    offer.author?._id === userId &&
                                    offer?.availabilityDates?.length > 0 && (

                                        <div className='topBorder'>
                                            <h3>Disponibilités enregistrées</h3>
                                        {offer?.availabilityDates.map((range, index) => (
                                            <div key={index}>
                                            {dayjs(range.startDate).format("DD MMM YYYY")} -{" "}
                                            {dayjs(range.endDate).format("DD MMM YYYY")}
                                            </div>
                                        ))}
                                        </div>
                                    )}
                            </>
                            

                            <div className='topBorder mrgT10'>
                                <h3>Détails de l’offre</h3>
                                {/* description et règles */}
                                {offer.description && (
                                    <div className="horizontal iStart mrgT10 spaceBtw">
                                        <span className="txt15">{offer.description}</span>
                                    </div>
                                )}

                                <div className="mrgB10"></div>

                                {offer.rules && (
                                    <div className="horizontal iCenter mrgT10">
                                        <span className="txt15">{offer.rules}</span>
                                    </div>
                                )}

                                {offer.contrat === "Vente" && (offer.handDelivery || offer.shipping) && (
                                    <div className="horizontal iCenter mrgT10" style={{ gap: 16 }}>
                                        {offer.handDelivery && (
                                            <div className="horizontal iCenter">
                                                <IconPackage width={16} height={16} className="mrgR5" />
                                                <span className="txt13">Remise en main propre</span>
                                            </div>
                                        )}
                                        {offer.shipping && (
                                            <div className="horizontal iCenter">
                                                <IconTruckDelivery width={16} height={16} className="mrgR5" />
                                                <span className="txt13">Livraison</span>
                                            </div>
                                        )}
                                    </div>
                                )}

                                <div className="mrgB10"></div>

                            </div>
                            {offer.author?._id !== userId &&
                                <>
                                    {offer.status === "open" && (
                                        <div className='mrgT20 mrgB150'>
                                            <Button color="gray" radius="xl"
                                                onClick={handleOpenChat}
                                                disabled={isOpeningChat}
                                                loading={isOpeningChat}
                                                >
                                                Contacter l'annonceur
                                            </Button>
                                        </div>
                                    )}
                                </>
                            }
                            {offer.author?._id !== userId && 
                                <>
                                {offer.contrat === "Location" && 
                                    <div className='fixedBottomContainer'> 
                                        {/* disponibilités si location */}
                                        {offer.contrat === "Location" && (
                                            <div className="mrgT5">
                                                {offer.status !== "booked" && myLock ? (
                                                    <div className="reserved-info mrgT20">
                                                        <div className='vertical'>
                                                            <div>
                                                                <p className="txt16 bold mediumPlus noMrgTB">                                                                    
                                                                    {computeTotalPrice().toLocaleString("fr-FR", {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                        })} € TTC
                                                                </p>
                                                            </div>
                                                            <p className="txt12 dGreyT noMrgTB">
                                                                dont {computeCommission().toLocaleString("fr-FR", {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                                })} € de frais de service (TVA incluse)
                                                            </p>
                                                            {offer.caution > 0 && (
                                                                <p className="txt12 dGreyT noMrgTB">
                                                                    + {Number(offer.caution).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} € de caution (non débitée)
                                                                </p>
                                                            )}

                                                            <p className="txt13 mrgT5 noMrgB">
                                                                {computeNbOfRentUnits()} jour(s) · {" "}
                                                                {new Date(myLock.start).toLocaleDateString("fr-FR")} → {" "}
                                                                {new Date(myLock.end).toLocaleDateString("fr-FR")}
                                                            </p>
                                                            <div className='vertical'>
                                                                
                                                                <p className='txt12 noMrgTB' style={{ color: lockSecondsLeft !== null && lockSecondsLeft < 60 ? "#e03131" : "#2f9e44" }}>
                                                                    Créneau réservé · {fmtCountdown(lockSecondsLeft)}
                                                                </p>
                                                                <p className='txt13 noMrgT mrgB10 underline medium'
                                                                    onClick={handleModifyBooking}
                                                                    style={{ cursor: "pointer" }}
                                                                    >
                                                                    Modifier
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className='w30'>
                                                            <Button
                                                                color="dark"
                                                                radius="xl"
                                                                className="mrgT5"
                                                                disabled={isPaying}
                                                                loading={isPaying}
                                                                onClick={() => {
                                                                    if (!isAddressComplete(user?.company?.address)) {
                                                                    setAddressModal(true);

                                                                    setTimeout(() => {
                                                                        navigate("/app/profile/account");
                                                                    }, 2000);

                                                                    return;
                                                                    }

                                                                    handlePayment(offer._id, computeNbOfRentUnits(), myLock);
                                                                }}
                                                                >
                                                                Réserver
                                                                </Button>
                                                        </div>
                                                    </div>
                                                ) : chatStart && chatEnd ? (
                                                    <div className='horizontal spaceBtw width90pCenter iCenter'>
                                                        <div className='vertical'>
                                                            <p className="txt13 mrgT5 noMrgB">
                                                                {Math.max(1, Math.round((new Date(chatEnd) - new Date(chatStart)) / 86400000) + 1)} jour(s) · {" "}
                                                                {new Date(chatStart).toLocaleDateString("fr-FR")} → {" "}
                                                                {new Date(chatEnd).toLocaleDateString("fr-FR")}
                                                            </p>
                                                            <p className='txt13 noMrgT mrgB10 underline medium'
                                                                onClick={() => openBookingModal(chatStart, chatEnd)}
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                Modifier
                                                            </p>
                                                        </div>
                                                        <div className='w30'>
                                                            <Button
                                                                color="dark"
                                                                radius="xl"
                                                                className="mrgT5"
                                                                disabled={isPaying}
                                                                loading={isPaying}
                                                                onClick={async () => {
                                                                    if (isPaying) return;
                                                                    if (!isAddressComplete(user?.company?.address)) {
                                                                        setAddressModal(true);
                                                                        setTimeout(() => navigate("/app/profile/account"), 2000);
                                                                        return;
                                                                    }
                                                                    setIsPaying(true);
                                                                    try {
                                                                        const token = localStorage.getItem("token");
                                                                        const lockRes = await fetch(
                                                                            `https://boldee-97d8d36af3bd.herokuapp.com/app/offers/book-temp/${offer._id}`,
                                                                            { method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` }, body: JSON.stringify({ rangeDates: [chatStart, chatEnd] }) }
                                                                        );
                                                                        const lockData = await lockRes.json();
                                                                        if (!lockRes.ok) { alert(lockData.message || "Créneau non disponible."); setIsPaying(false); return; }
                                                                        if (lockData.lock) {
                                                                            setLocks(prev => [...prev.filter(l => l.user !== userId), lockData.lock]);
                                                                            setCurrentLockId(lockData.lock.id);
                                                                            const nbDays = Math.max(1, Math.round((new Date(chatEnd) - new Date(chatStart)) / 86400000) + 1);
                                                                            await handlePayment(offer._id, nbDays, lockData.lock);
                                                                        } else {
                                                                            setIsPaying(false);
                                                                        }
                                                                    } catch (err) {
                                                                        console.error(err);
                                                                        setIsPaying(false);
                                                                    }
                                                                }}
                                                            >
                                                                Réserver
                                                            </Button>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className='horizontal spaceBtw width90pCenter iCenter'>
                                                        <div className='txt11 medium w35'>
                                                            Indiquez vos dates pour afficher les prix
                                                        </div>
                                                        <Button
                                                            color="dark"
                                                            radius="xl"
                                                            className="mrgT10 mrgB10"
                                                            onClick={openBookingModal}
                                                        >
                                                            Vérifier la disponibilité
                                                        </Button>
                                                    </div>
                                                )}

                                                <Modal
                                                    opened={modalOpened}
                                                    onClose={() => setModalOpened(false)}
                                                    title="Sélectionnez vos dates de réservation"
                                                    size="xs"
                                                    centered
                                                    lockScroll={false}  
                                                >
                                                <DatePicker
                                                    size="sm"
                                                    locale="fr"
                                                    numberOfColumns={1}
                                                    minDate={addDays(new Date(), 1)}
                                                    defaultDate={(() => {
                                                        const upcomingRanges = (offer?.availabilityDates || [])
                                                            .filter(r => new Date(r.endDate) >= new Date())
                                                            .sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
                                                        return upcomingRanges[0] ? new Date(upcomingRanges[0].startDate) : new Date();
                                                    })()}
                                                    value={
                                                        Array.isArray(selectedRange)
                                                            ? selectedRange
                                                            : [null, null]
                                                        }
                                                    type="range"
                                                    allowSingleDateInRange

                                                    excludeDate={(date) => isDateUnavailable(date)}

                                                    onChange={(value) => {
                                                        setSelectedRange(value || [null, null]);
                                                    }}

                                                    renderDay={(date) => {

                                                        const [start, end] = selectedRange || [];

                                                        const inRange =
                                                        start &&
                                                        end &&
                                                        date >= start &&
                                                        date <= end;

                                                        return (
                                                        <div
                                                            style={{
                                                            width: 32,
                                                            height: 32,
                                                            borderRadius: 6,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            backgroundColor: inRange ? "#006e10" : undefined,
                                                            color: inRange ? "white" : undefined,
                                                            }}
                                                        >
                                                            {date.getDate()}
                                                        </div>
                                                        );
                                                    }}
                                                />

                                                {offer?.availabilityDates?.length > 0 && (
                                                    <div style={{ marginTop: 10 }}>
                                                        <p style={{ fontSize: 12, color: '#868e96', marginBottom: 4 }}>
                                                            Périodes disponibles :
                                                        </p>
                                                        {offer.availabilityDates
                                                            .filter(r => r?.startDate && r?.endDate && new Date(r.endDate) >= new Date())
                                                            .map((r, i) => (
                                                                <p key={i} style={{ fontSize: 12, margin: '2px 0', color: '#495057' }}>
                                                                    Du {new Date(r.startDate).toLocaleDateString("fr-FR")} au {new Date(r.endDate).toLocaleDateString("fr-FR")}
                                                                </p>
                                                            ))
                                                        }
                                                    </div>
                                                )}

                                                <Button
                                                    color="dark"
                                                    className="mrgT10"
                                                    disabled={!selectedRange[0]}
                                                    onClick={handleConfirmBooking}
                                                >
                                                Confirmer
                                                </Button>

                                                </Modal>
                                            </div>
                                        )}
                                    </div>
                                }
                                {offer.contrat !== "Location" && 
                                    <div className='fixedBottomContainer'> 
                                        
                                        <div className="mrgT5">
                                                {offer.status !== "booked" && (
                                                    <div className="reserved-info mrgT20">
                                                        <div className='vertical mrgB20'>                                                            
                                                            <p className="txt16 bold mediumPlus noMrgTB">
                                                                {computeTotalPrice().toLocaleString("fr-FR", {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })} € TTC
                                                            </p>
                                                            <p className='txt12 dGreyT noMrgTB'>
                                                                dont {computeCommission().toLocaleString("fr-FR", {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })} € de frais de service (TVA incluse)
                                                            
                                                                {offer.contrat === "Don" &&
                                                                <> - Don</>
                                                                }
                                                            </p>
                                                            <p className='txt13 noMrgTB'>
                                                                ✔ Annulation gratuite
                                                            </p>
                                                        </div>
                                                        <div className='w30 mrgB20'>
                                                            <Button
                                                            color="dark"
                                                            radius="xl"
                                                            className='mrgT5'
                                                            disabled={isPaying}
                                                            loading={isPaying}
                                                            onClick={() => {
                                                                if (!isAddressComplete(user?.company?.address)) {
                                                                setAddressModal(true);

                                                                setTimeout(() => {
                                                                    navigate("/app/profile/account");
                                                                }, 4000);

                                                                return;
                                                                }

                                                                handlePayment(offer._id, computeNbOfRentUnits());
                                                            }}
                                                            >
                                                            Réserver
                                                            </Button>
                                                        </div>

                                                    </div>
                                                )}
                                            </div>


                                    </div>
                                }
                                <Modal
                                opened={addressModal}
                                onClose={() => setAddressModal(false)}
                                centered
                                >
                                <div className="vertical">
                                    <p className='medium noMrgT mrgB5 txt18'>Adresse requise avant réservation </p>
                                    <p className='noMrgTB'>Redirection vers votre profil…</p>
                                </div>
                                </Modal>
                                </>
                            }
                            <Modal
                                opened={companyModalOpened}
                                onClose={() => setCompanyModalOpened(false)}
                                centered
                                title={offer.author?.company?.name}
                            >
                                <div className="vertical">
                                    <p className='noMrgTB'>
                                        {offer.author?.company?.address?.city || offer.author?.company?.address?.postalcode
                                            ? `${offer.author?.company?.address?.postalcode || ""} ${offer.author?.company?.address?.city || ""}`.trim()
                                            : "Localisation non renseignée"}
                                    </p>
                                    <div className='mrgB10'></div>
                                    <p className='noMrgTB'>
                                        {offer.author?.company?.description || "Aucune description renseignée."}
                                    </p>
                                </div>
                            </Modal>
                            {offer.co2Estimate &&
                                <Modal
                                    opened={co2ModalOpened}
                                    onClose={() => setCo2ModalOpened(false)}
                                    centered
                                    title="Comment est calculé ce chiffre ?"
                                >
                                    <div className="vertical">
                                        <p className='noMrgTB'>
                                            {offer.author?._id === userId
                                                ? "En mettant cette ressource en réemploi plutôt qu'au rebut, vous permettez potentiellement d'éviter la fabrication d'un équivalent neuf. Ce chiffre estime l'impact CO₂ évité grâce à cette mise en réemploi."
                                                : "En choisissant cette ressource réemployée plutôt qu'un équivalent neuf, vous évitez potentiellement l'impact CO₂ lié à sa fabrication. Ce chiffre est une estimation basée sur le facteur d'impact de cette catégorie."}
                                        </p>
                                        <div className='mrgB10'></div>
                                        <p className='txt13 dGreyT noMrgTB'>
                                            Ce chiffre correspond à 1 objet.
                                        </p>
                                        <div className='mrgB10'></div>
                                        <p className='txt13 dGreyT noMrgTB'>
                                            Source : ADEME, Base Carbone ({offer.co2Estimate.factorYear}).
                                        </p>
                                    </div>
                                </Modal>
                            }
                        </div>
                    </>
                ) : (
                    <>
                        <div className="offer-desktop-page-bg">
                        <div className="offer-desktop-layout">
                        <div className="offer-desktop-carousel-col">
                            <Carousel
                                height={480}
                                slideSize="100%"
                                loop
                                align="start">

                                {offer.pictures.length > 0
                                    ?   <>
                                            {offer.pictures.map((url) => (
                                                <Carousel.Slide key={url}>
                                                    <img className="imgCarroussel"
                                                        src={url}
                                                        alt='img_rsc'/>
                                                </Carousel.Slide>
                                            ))}
                                        </>
                                    :   <>
                                            <div className='horizontal iCenter jCenter w100 dGreyT'><IconPhoto width={48} height={48}/></div>
                                        </>
                                }
                            </Carousel>

                            {isEditOffer
                                ?   <ClosePageOverPictureButtonwithModal />
                                :   desktopBackButton
                                    ?   desktopBackButton
                                    :   ""
                            }
                        </div>

                        <div className="offer-desktop-info-col">
                        <div className="offer-first-lines-info">
                            {(offer.status === "open") && (offer.contrat === "Location") && (new Date(offer?.availabilityDates[1]) > today)
                                ?   <div>
                                        <p className='txt15 rT mediumplus txtCenter'>Mettez à jour les disponibilités de votre location.</p>
                                    </div>
                                    :   ""
                            }
                            {/* titre */}
                            <div className='horizontal spaceBtw iEnd'>
                                <h1 className="txt20 mrgT20 mrgB5 wraped">{offer.title}</h1>
                                {userId !== offer?.author?._id && (
                                <div
                                    onClick={toggleFavorite}
                                    style={{ cursor: "pointer" }}
                                >
                                    {isFavorite ? (
                                    <IconHeartFilled size={26} stroke={1.5} fill="red" />
                                    ) : (
                                    <IconHeart size={26} stroke={1.5} />
                                    )}
                                </div>
                                )}
                            </div>
                            
                            {/* prix */}
                            <div className='horizontal'>
                                <div>
                                    {offer.price != null && (
                                        <h1 className="txt20 mediumPlus noMrgT noMrgB mrgR5">
                                            {Number(offer.price).toFixed(2)} €
                                        </h1>
                                    )}
                                </div>
                                <div>
                                    {offer.contrat === "Location" && (
                                        <h1 className="txt20 mediumPlus noMrgT noMrgB">/ jour</h1>
                                    )}
                                </div>
                            </div>
                            {offer.contrat === "Location" && offer.caution > 0 && (
                                <p className="noMrgT txt13" style={{ color: "#666" }}>
                                    Caution : {Number(offer.caution).toFixed(2)} €
                                </p>
                            )}

                            {/* type de contrat */}
                            <div>
                                {offer.contrat === "Vente" && (
                                    <div className='horizontal iCenter'>
                                        <div className='noMrgTB'><IconTag width={15} height={12} /></div>
                                        <div className="txt13 noMrgTB"><p className='noMrgTB mrgL3'>Vente sécurisée</p></div>
                                    </div>
                                )}
                                {offer.contrat === "Location" && (
                                    <div className='horizontal iCenter'>
                                        <div className='noMrgTB'><IconKey width={15} height={12} /></div>
                                        <div className="txt13 noMrgTB"><p className='noMrgTB mrgL3'>Location sécurisée</p></div>
                                    </div>
                                )}
                                {offer.contrat === "Don" && (
                                    <div className='horizontal iCenter'>
                                        <div className='noMrgTB'><IconGift width={15} height={12} /></div>
                                        <div className="txt13 noMrgTB"><p className='noMrgTB mrgL3'>Don</p></div>
                                    </div>
                                )}

                            </div>

                            {/* impact CO2 : estimation, Vente/Don uniquement */}
                            {offer.contrat !== "Location" && offer.co2Estimate && (
                                <div className="horizontal iCenter mrgT5" style={{ gap: 6 }}>
                                    <IconLeaf width={15} height={15} color="#2e7d32" />
                                    <p className="txt13 noMrgTB" style={{ color: '#2e7d32' }}>
                                        ≈ {offer.co2Estimate.avoidedKg} kg CO₂e potentiellement évités
                                    </p>
                                    <IconInfoCircle
                                        width={14}
                                        height={14}
                                        color="#999"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => setCo2ModalOpened(true)}
                                    />
                                </div>
                            )}

                            {/* lieu de la ressource */}
                            <div className="horizontal spaceBtw wraped mrgT10 medium noMrgB">
                                <div className="horizontal iCenter mrgB5 mrgR20">
                                    <IconMapPin width={15} height={15} className="mrgR10" />
                                    <span className="txt15">{offer.cityOfIntervention}</span>
                                </div>
                            </div>

                            <> {offer.author?.company
                                    ?
                                        <div className="horizontal spaceBtw wraped noMrgT medium">
                                            <div
                                                className="horizontal iCenter mrgB10 mrgR20"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => setCompanyModalOpened(true)}
                                            >
                                                <IconBuildingEstate width={15} height={15} className="mrgR10" />
                                                <div className="txt15 underline">{offer.author?.company?.name}</div>
                                            </div>
                                        </div>
                                    : ""
                                }
                            </>

                            <>
                                
                                {offer.contrat === "Location" &&
                                    offer.author?._id === userId &&
                                    offer?.availabilityDates?.length > 0 && (

                                        <div className='topBorder'>
                                            <h3>Disponibilités enregistrées</h3>
                                        {offer?.availabilityDates.map((range, index) => (
                                            <div key={index}>
                                            {dayjs(range.startDate).format("DD MMM YYYY")} -{" "}
                                            {dayjs(range.endDate).format("DD MMM YYYY")}
                                            </div>
                                        ))}
                                        </div>
                                    )}
                            </>
                          

                            <div className='topBorder mrgT10'>
                                <h3>Détails de l’offre</h3>
                                {/* description et règles */}
                                {offer.description && (
                                    <div className="horizontal iStart mrgT10 spaceBtw">
                                        <span className="txt15">{offer.description}</span>
                                    </div>
                                )}

                                <div className="mrgB10"></div>

                                {offer.rules && (
                                    <div className="horizontal iCenter mrgT10">
                                        <span className="txt15">{offer.rules}</span>
                                    </div>
                                )}

                                {offer.contrat === "Vente" && (offer.handDelivery || offer.shipping) && (
                                    <div className="horizontal iCenter mrgT10" style={{ gap: 16 }}>
                                        {offer.handDelivery && (
                                            <div className="horizontal iCenter">
                                                <IconPackage width={16} height={16} className="mrgR5" />
                                                <span className="txt13">Remise en main propre</span>
                                            </div>
                                        )}
                                        {offer.shipping && (
                                            <div className="horizontal iCenter">
                                                <IconTruckDelivery width={16} height={16} className="mrgR5" />
                                                <span className="txt13">Livraison</span>
                                            </div>
                                        )}
                                    </div>
                                )}

                                <div className="mrgB10"></div>

                            </div>
                            {offer.author?._id !== userId &&
                                <>
                                    {offer.status === "open" && offer.contrat !== "Location" && (
                                        <div className='mrgT20 mrgB20'>
                                            <Button color="gray" radius="xl" size="lg" styles={{ label: { fontSize: 16, fontWeight: 500 } }}
                                                style={{ width: 220 }}
                                                onClick={handleOpenChat}
                                                disabled={isOpeningChat}
                                                loading={isOpeningChat}
                                                >
                                                Contacter l'annonceur
                                            </Button>
                                        </div>
                                    )}
                                </>
                            }
                            {offer.author?._id !== userId &&
                                <>
                                {offer.contrat === "Location" &&
                                    <div className='fixedBottomContainer'> 
                                        {/* disponibilités si location */}
                                        {offer.contrat === "Location" && (
                                            <div className="mrgT5">
                                                {offer.status !== "booked" && myLock ? (
                                                    <div className='vertical iStart'>
                                                    {offer.author?._id !== userId && offer.status === "open" && (
                                                        <Button color="gray" radius="xl" size="lg" styles={{ label: { fontSize: 16, fontWeight: 500 } }}
                                                            className="mrgT20"
                                                            style={{ width: 220 }}
                                                            onClick={handleOpenChat}
                                                            disabled={isOpeningChat}
                                                            loading={isOpeningChat}
                                                            >
                                                            Contacter l'annonceur
                                                        </Button>
                                                    )}
                                                    <div className="reserved-info mrgT20">
                                                        <div className='vertical'>
                                                            <div>
                                                                <p className="txt16 bold mediumPlus noMrgTB">
                                                                    {computeTotalPrice().toLocaleString("fr-FR", {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 2
                                                                        })} € TTC
                                                                </p>
                                                            </div>
                                                            <p className="txt12 dGreyT noMrgTB">
                                                                dont {computeCommission().toLocaleString("fr-FR", {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                                })} € de frais de service (TVA incluse)
                                                            </p>
                                                            {offer.caution > 0 && (
                                                                <p className="txt12 dGreyT noMrgTB">
                                                                    + {Number(offer.caution).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} € de caution (non débitée)
                                                                </p>
                                                            )}

                                                            <p className="txt13 mrgT5 noMrgB">
                                                                {computeNbOfRentUnits()} jour(s) · {" "}
                                                                {new Date(myLock.start).toLocaleDateString("fr-FR")} → {" "}
                                                                {new Date(myLock.end).toLocaleDateString("fr-FR")}
                                                            </p>
                                                            <div className='vertical'>

                                                                <p className='txt12 noMrgTB' style={{ color: lockSecondsLeft !== null && lockSecondsLeft < 60 ? "#e03131" : "#2f9e44" }}>
                                                                    Créneau réservé · {fmtCountdown(lockSecondsLeft)}
                                                                </p>
                                                                <p className='txt13 noMrgT mrgB10 underline medium'
                                                                    onClick={handleModifyBooking}
                                                                    style={{ cursor: "pointer" }}
                                                                    >
                                                                    Modifier
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className='w30'>
                                                            <Button
                                                                color="dark" size="lg" styles={{ label: { fontSize: 16, fontWeight: 500 } }}
                                                                radius="xl"
                                                                className="mrgT5"
                                                                style={{ width: 220 }}
                                                                disabled={isPaying}
                                                                loading={isPaying}
                                                                onClick={() => {
                                                                    if (!isAddressComplete(user?.company?.address)) {
                                                                    setAddressModal(true);

                                                                    setTimeout(() => {
                                                                        navigate("/app/profile/account");
                                                                    }, 2000);

                                                                    return;
                                                                    }

                                                                    handlePayment(offer._id, computeNbOfRentUnits(), myLock);
                                                                }}
                                                                >
                                                                Réserver
                                                                </Button>
                                                        </div>
                                                    </div>
                                                    </div>
                                                ) : chatStart && chatEnd ? (
                                                    <div className='vertical iStart'>
                                                    {offer.author?._id !== userId && offer.status === "open" && (
                                                        <Button color="gray" radius="xl" size="lg" styles={{ label: { fontSize: 16, fontWeight: 500 } }}
                                                            className="mrgT20"
                                                            style={{ width: 220 }}
                                                            onClick={handleOpenChat}
                                                            disabled={isOpeningChat}
                                                            loading={isOpeningChat}
                                                            >
                                                            Contacter l'annonceur
                                                        </Button>
                                                    )}
                                                    <div className='horizontal spaceBtw width90pCenter iCenter mrgT20'>
                                                        <div className='vertical'>
                                                            <p className="txt13 mrgT5 noMrgB">
                                                                {Math.max(1, Math.round((new Date(chatEnd) - new Date(chatStart)) / 86400000) + 1)} jour(s) · {" "}
                                                                {new Date(chatStart).toLocaleDateString("fr-FR")} → {" "}
                                                                {new Date(chatEnd).toLocaleDateString("fr-FR")}
                                                            </p>
                                                            <p className='txt13 noMrgT mrgB10 underline medium'
                                                                onClick={() => openBookingModal(chatStart, chatEnd)}
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                Modifier
                                                            </p>
                                                        </div>
                                                        <div className='w30'>
                                                            <Button
                                                                color="dark" size="lg" styles={{ label: { fontSize: 16, fontWeight: 500 } }}
                                                                radius="xl"
                                                                className="mrgT5"
                                                                style={{ width: 220 }}
                                                                disabled={isPaying}
                                                                loading={isPaying}
                                                                onClick={async () => {
                                                                    if (isPaying) return;
                                                                    if (!isAddressComplete(user?.company?.address)) {
                                                                        setAddressModal(true);
                                                                        setTimeout(() => navigate("/app/profile/account"), 2000);
                                                                        return;
                                                                    }
                                                                    setIsPaying(true);
                                                                    try {
                                                                        const token = localStorage.getItem("token");
                                                                        const lockRes = await fetch(
                                                                            `https://boldee-97d8d36af3bd.herokuapp.com/app/offers/book-temp/${offer._id}`,
                                                                            { method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` }, body: JSON.stringify({ rangeDates: [chatStart, chatEnd] }) }
                                                                        );
                                                                        const lockData = await lockRes.json();
                                                                        if (!lockRes.ok) { alert(lockData.message || "Créneau non disponible."); setIsPaying(false); return; }
                                                                        if (lockData.lock) {
                                                                            setLocks(prev => [...prev.filter(l => l.user !== userId), lockData.lock]);
                                                                            setCurrentLockId(lockData.lock.id);
                                                                            const nbDays = Math.max(1, Math.round((new Date(chatEnd) - new Date(chatStart)) / 86400000) + 1);
                                                                            await handlePayment(offer._id, nbDays, lockData.lock);
                                                                        } else {
                                                                            setIsPaying(false);
                                                                        }
                                                                    } catch (err) {
                                                                        console.error(err);
                                                                        setIsPaying(false);
                                                                    }
                                                                }}
                                                            >
                                                                Réserver
                                                            </Button>
                                                        </div>
                                                    </div>
                                                    </div>
                                                ) : (
                                                    <div className='horizontal mrgT10 mrgB10' style={{ gap: 12, alignItems: 'flex-start' }}>
                                                        {offer.author?._id !== userId && offer.status === "open" && (
                                                            <Button color="gray" radius="xl" size="lg" styles={{ label: { fontSize: 16, fontWeight: 500 } }}
                                                                onClick={handleOpenChat}
                                                                disabled={isOpeningChat}
                                                                loading={isOpeningChat}
                                                                >
                                                                Contacter l'annonceur
                                                            </Button>
                                                        )}
                                                        <div className='vertical iCenter'>
                                                            <Button
                                                                color="dark" size="lg" styles={{ label: { fontSize: 16, fontWeight: 500 } }}
                                                                radius="xl"
                                                                onClick={openBookingModal}
                                                            >
                                                                Vérifier la disponibilité
                                                            </Button>
                                                            <div className='txt11 medium mrgT5'>
                                                                Indiquez vos dates pour afficher les prix
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                <Modal
                                                    opened={modalOpened}
                                                    onClose={() => setModalOpened(false)}
                                                    title="Sélectionnez vos dates de réservation"
                                                    size="xs"
                                                    centered
                                                    lockScroll={false}  
                                                >
                                                <DatePicker
                                                    size="sm"
                                                    locale="fr"
                                                    numberOfColumns={1}
                                                    minDate={addDays(new Date(), 1)}
                                                    defaultDate={(() => {
                                                        const upcomingRanges = (offer?.availabilityDates || [])
                                                            .filter(r => new Date(r.endDate) >= new Date())
                                                            .sort((a, b) => new Date(a.startDate) - new Date(b.startDate));
                                                        return upcomingRanges[0] ? new Date(upcomingRanges[0].startDate) : new Date();
                                                    })()}
                                                    value={
                                                        Array.isArray(selectedRange)
                                                            ? selectedRange
                                                            : [null, null]
                                                        }
                                                    type={
                                                        offer.rentUnit === "semaine"
                                                            ? "default"
                                                            : "range"
                                                    }
                                                    allowSingleDateInRange

                                                    excludeDate={(date) => {
                                                    if (offer.rentUnit === "semaine") {
                                                        if (!isMonday(date)) return true;
                                                    }
                                                    return isDateUnavailable(date);
                                                    }}

                                                    onChange={(value) => {
                                                        if (!value) {
                                                        setSelectedRange([null, null]);
                                                        return;
                                                        }

                                                        if (offer.rentUnit === "semaine") {
                                                        if (!isMonday(value)) return;
                                                        const [monday, sunday] = computeWeekRange(value);
                                                        setSelectedRange([monday, sunday]);
                                                        return;
                                                        }

                                                        if (offer.rentUnit === "mois") {
                                                        if (!value) {
                                                            setSelectedRange([null, null]);
                                                            return;
                                                        }

                                                        const [startRaw, endRaw] = value;

                                                        // 🔹 1er clic → on affiche juste le début
                                                        if (startRaw && !endRaw) {
                                                            setSelectedRange([startRaw, null]);
                                                            return;
                                                        }

                                                        if (!startRaw || !endRaw) return;

                                                        const start = normalize(startRaw);
                                                        const end = normalize(endRaw);

                                                        const totalDays =
                                                            differenceInCalendarDays(end, start) + 1;

                                                        // minimum 30 jours
                                                        if (totalDays < 30) {
                                                            setSelectedRange([startRaw, null]);
                                                            return;
                                                        }

                                                        const monthsCount = Math.ceil(totalDays / 30);
                                                        const adjustedEnd = addDays(start, monthsCount * 30 - 1);

                                                        let current = start;
                                                        while (current <= adjustedEnd) {
                                                            if (isDateUnavailable(current)) {
                                                            setSelectedRange([startRaw, null]);
                                                            return;
                                                            }
                                                            current = addDays(current, 1);
                                                        }

                                                        setSelectedRange([start, adjustedEnd]);
                                                        return;
                                                        }

                                                        setSelectedRange(value || [null, null]);
                                                    }}

                                                    renderDay={(date) => {

                                                        const [start, end] = selectedRange || [];

                                                        const inRange =
                                                        start &&
                                                        end &&
                                                        date >= start &&
                                                        date <= end;

                                                        return (
                                                        <div
                                                            style={{
                                                            width: 32,
                                                            height: 32,
                                                            borderRadius: 6,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            backgroundColor: inRange ? "#006e10" : undefined,
                                                            color: inRange ? "white" : undefined,
                                                            }}
                                                        >
                                                            {date.getDate()}
                                                        </div>
                                                        );
                                                    }}
                                                />

                                                {offer?.availabilityDates?.length > 0 && (
                                                    <div style={{ marginTop: 10 }}>
                                                        <p style={{ fontSize: 12, color: '#868e96', marginBottom: 4 }}>
                                                            Périodes disponibles :
                                                        </p>
                                                        {offer.availabilityDates
                                                            .filter(r => r?.startDate && r?.endDate && new Date(r.endDate) >= new Date())
                                                            .map((r, i) => (
                                                                <p key={i} style={{ fontSize: 12, margin: '2px 0', color: '#495057' }}>
                                                                    Du {new Date(r.startDate).toLocaleDateString("fr-FR")} au {new Date(r.endDate).toLocaleDateString("fr-FR")}
                                                                </p>
                                                            ))
                                                        }
                                                    </div>
                                                )}

                                                <Button
                                                    color="dark" size="lg" styles={{ label: { fontSize: 16, fontWeight: 500 } }}
                                                    className="mrgT10"
                                                    disabled={!selectedRange[0]}
                                                    onClick={handleConfirmBooking}
                                                >
                                                Confirmer
                                                </Button>

                                                </Modal>
                                            </div>
                                        )}
                                    </div>
                                }
                                {offer.contrat !== "Location" &&
                                    <div className='fixedBottomContainer'> 
                                        
                                        <div className="mrgT5">
                                                {offer.status !== "booked" && (
                                                    <div className="reserved-info mrgT20">
                                                        <div className='vertical mrgB20'>                                                            
                                                            <p className="txt16 bold mediumPlus noMrgTB">
                                                                {computeTotalPrice().toLocaleString("fr-FR", {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })} € TTC
                                                            </p>
                                                            <p className='txt12 dGreyT noMrgTB'>
                                                                dont {computeCommission().toLocaleString("fr-FR", {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2
                                                                })} € de frais de service (TVA incluse)
                                                            
                                                                {offer.contrat === "Don" &&
                                                                <> - Don</>
                                                                }
                                                            </p>
                                                            <p className='txt13 noMrgTB'>
                                                                ✔ Annulation gratuite
                                                            </p>
                                                        </div>
                                                        <div className='w30 mrgB20'>
                                                            <Button
                                                            color="dark" size="lg" styles={{ label: { fontSize: 16, fontWeight: 500 } }}
                                                            radius="xl"
                                                            className='mrgT5'
                                                            style={{ width: 220 }}
                                                            disabled={isPaying}
                                                            loading={isPaying}
                                                            onClick={() => {
                                                                if (!isAddressComplete(user?.company?.address)) {
                                                                setAddressModal(true);

                                                                setTimeout(() => {
                                                                    navigate("/app/profile/account");
                                                                }, 4000);

                                                                return;
                                                                }

                                                                handlePayment(offer._id, computeNbOfRentUnits());
                                                            }}
                                                            >
                                                            Réserver
                                                            </Button>
                                                        </div>

                                                    </div>
                                                )}
                                            </div>


                                    </div>
                                }
                                <Modal
                                opened={addressModal}
                                onClose={() => setAddressModal(false)}
                                centered
                                >
                                <div className="vertical">
                                    <p className='medium noMrgT mrgB5 txt18'>Adresse requise avant réservation </p>
                                    <p className='noMrgTB'>Redirection vers votre profil…</p>
                                </div>
                                </Modal>
                                </>
                            }
                            <Modal
                                opened={companyModalOpened}
                                onClose={() => setCompanyModalOpened(false)}
                                centered
                                title={offer.author?.company?.name}
                            >
                                <div className="vertical">
                                    <p className='noMrgTB'>
                                        {offer.author?.company?.address?.city || offer.author?.company?.address?.postalcode
                                            ? `${offer.author?.company?.address?.postalcode || ""} ${offer.author?.company?.address?.city || ""}`.trim()
                                            : "Localisation non renseignée"}
                                    </p>
                                    <div className='mrgB10'></div>
                                    <p className='noMrgTB'>
                                        {offer.author?.company?.description || "Aucune description renseignée."}
                                    </p>
                                </div>
                            </Modal>
                            {offer.co2Estimate &&
                                <Modal
                                    opened={co2ModalOpened}
                                    onClose={() => setCo2ModalOpened(false)}
                                    centered
                                    title="Comment est calculé ce chiffre ?"
                                >
                                    <div className="vertical">
                                        <p className='noMrgTB'>
                                            {offer.author?._id === userId
                                                ? "En mettant cette ressource en réemploi plutôt qu'au rebut, vous permettez potentiellement d'éviter la fabrication d'un équivalent neuf. Ce chiffre estime l'impact CO₂ évité grâce à cette mise en réemploi."
                                                : "En choisissant cette ressource réemployée plutôt qu'un équivalent neuf, vous évitez potentiellement l'impact CO₂ lié à sa fabrication. Ce chiffre est une estimation basée sur le facteur d'impact de cette catégorie."}
                                        </p>
                                        <div className='mrgB10'></div>
                                        <p className='txt13 dGreyT noMrgTB'>
                                            Ce chiffre correspond à 1 objet.
                                        </p>
                                        <div className='mrgB10'></div>
                                        <p className='txt13 dGreyT noMrgTB'>
                                            Source : ADEME, Base Carbone ({offer.co2Estimate.factorYear}).
                                        </p>
                                    </div>
                                </Modal>
                            }
                            {desktopFooterActions &&
                                <div className="mrgT30">
                                    {desktopFooterActions}
                                </div>
                            }
                        </div>
                        </div>
                        </div>
                        </div>
                    </>
                )}
            </>
            :
            <div className="loaderWrapper vertical">
                <Loader color="green" size="sm" type="dots" />
                <div className='mrgT5'>Chargement ...</div>
            </div>
    )

}

export default OfferCard;